import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import {
   PopWrap,
   SearchBar,
   SearchInput,
   SectionBlock,
   SectionTitle,
   OptionRow,
   HiddenCheckbox,
   Box,
   FooterBar,
} from '../styles/FilterDropdownStyle';
import type { FilterDropdownProps, FilterState } from '../../types/FilterStateInterface';



const groups: { key: keyof FilterState; title: string; options: string[] }[] = [
   { key: 'types', title: 'Transaction Type', options: ['Crypto', /* 'Giftcard', */ 'Wallet Top-up', 'Withdrawal'] },
   { key: 'statuses', title: 'Status', options: ['Pending', 'Completed', 'Failed'] },
   { key: 'ranges', title: 'Date Range', options: ['Today', 'This Week', 'This Month'] },
];


const FilterDropdown: React.FC<FilterDropdownProps> = ({ open, onClose, value, onChange, anchorRef }) => {
   const wrapRef = useRef<HTMLDivElement | null>(null);
   const [query, setQuery] = useState('');

   useEffect(() => {
      function handle(e: MouseEvent) {
         if (!open) return;
         if (wrapRef.current && !wrapRef.current.contains(e.target as Node) && anchorRef.current && !anchorRef.current.contains(e.target as Node)) onClose();
      }

      window.addEventListener('mousedown', handle);
      return () => window.removeEventListener('mousedown', handle);
   }, [open, onClose, anchorRef]);

   function toggle(group: keyof FilterState, option: string) {
      const current = value[group];
      if (current.includes(option)) {
         onChange({ ...value, [group]: [] });
      } else {
         onChange({ ...value, [group]: [option] });
      }
   }

   if (!open) return null;

   return (
      <PopWrap ref={wrapRef} role="dialog" aria-label="Filter options">
         <SearchBar>
            <Icon icon="solar:magnifer-linear" width={14} className="text-[#CACACC] mb-0.5" />
            <SearchInput
               placeholder="Search filters"
               value={query}
               onChange={e => setQuery(e.target.value)}
            />
         </SearchBar>

         {groups.map(g => {
            const filtered = g.options.filter(o => o.toLowerCase().includes(query.toLowerCase()));

            return (
               <SectionBlock key={g.key}>
                  <SectionTitle>{g.title}</SectionTitle>
                  {filtered.map(opt => {
                     const active = value[g.key].includes(opt);
                     return (
                        <OptionRow key={opt}>
                           <HiddenCheckbox
                              checked={active}
                              onChange={() => toggle(g.key, opt)}
                           />
                           <Box $checked={active}>{active && <Icon icon="solar:check-linear" width={12} />}</Box>
                           <span className='text-sm'>{opt}</span>
                        </OptionRow>
                     );
                  })}
               </SectionBlock>
            );
         })}

         <FooterBar>
            <Icon icon="solar:checklist-linear" width={14} />
            <span>
               {(() => {
                  const count = value.types.length + value.statuses.length + value.ranges.length;
                  return count === 0 ? 'Select categories' : `${count} categor${count === 1 ? 'y' : 'ies'} selected`;
               })()}
            </span>
         </FooterBar>
      </PopWrap>
   );
};

export default FilterDropdown;
